/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Item } from '@interfaces';

@Component({
  selector: 'unicon-select',
  templateUrl: './select.component.html',
})
export class SelectComponent {
  @Input() options: Item[] = [];
  @Input() placeholder: string = 'Seleccione una opción';
  @Input() multiple: boolean = false;
  @Input() disabled: boolean = false;
  @Input() customClass: string = '';
  @Input() selectedValue!: any;
  @Input() classWidth: string = 'w-full';
  @Output() selectionChange = new EventEmitter<any>();
  @Output() onOptionChange = new EventEmitter<any>();

  protected onSelectionChange(value: any) {
    this.selectionChange.emit(value);
  }

  protected onOptionClick(option: any) {
    this.onOptionChange.emit(option);
  }
}
